import { takeLatest, all } from 'redux-saga/effects'
import { AuthTypes } from '../Stores/Auth/Actions'
import { StationTypes } from '../Stores/Station/Actions'
import { ChargePointTypes } from '../Stores/ChargePoint/Actions'
import { OperatorUserTypes } from '../Stores/OperatorUser/Actions'
import { CardTypes } from '../Stores/Card/Actions'
import { OperatorUserActionsTypes } from '../Stores/OperatorUserActions/Actions'
import { OperatorsAlertTypes } from '../Stores/Alert/Actions'
import { AnalyticsTypes } from '../Stores/Analytics/Actions'
import { TariffTypes } from 'Stores/Tariff/Actions'

import {
  operatorUserLogin,
  fetchOperatorUser,
  operatorUserLogout,
  resetPassVerification,
  resetPass,
  onTwoFactorVerify,
  onTwoFactorSetupVerify,
} from './AuthSaga'

import {
  fetchStationList,
  fetchStationListCount,
  updateStation,
  addStation,
  fetchStationMoveList,
  deleteStation,
  fetchStationDetails,
  fetchStationMapClusters,
  fetchStationHeatMap,
  fetchStationMapClustersSearch,
} from './StationSaga'

import {
  fetchChargePointList,
  fetchChargePoint,
  fetchChargePointLogList,
  fetchChargePointTransactionList,
  fetchChargePointConfigList,
  updateChargePoint,
  updateChargePointConfig,
  deleteChargePoint,
  addChargePoint,
  moveChargePoint,
  updateChargePointFirmware,
  fetchChargePointUploadDiagnostics,
  requestChargePointUploadDiagnostics,
  fetchChargePointTariffsList,
  deleteChargePointTariffs,
  addChargePointTariffs,
  fetchChargePointPrivacyScheduleList,
  deleteChargePointPrivacyRules,
  addChargePointPrivacyRules,
  fetchChargePointAccessGroups,
  deleteChargePointAccessGroupsBulk,
  addChargePointAccessGroupsBulk,
  fetchChargePointUptimeStatistics,
  fetchConnectorsUtilization,
  fetchChargePointSubscribedAlerts,
  fetchChargePointAlerts,
  updateChargePointAlerts,
  fetchChargePointLocalList,
  updateChargePointLocalList,
  fetchChargePointChargingProfiles,
  fetchChargePointCompositeSchedule,
  clearChargePointChargingProfile,
  createChargePointChargingProfile,
  fetchConnectorTypes,
  uploadChargePointFirmware,
  fetchChargingSessionLogs,
  fetchChargingSessionDetails,
  fetchChargingSessionEvents,
  reverseTransaction,
  blockChargePoint,
} from './ChargePointSaga'

import {
  fetchOperatorUserList,
  updateOperatorUser,
  fetchInviteOperatorUserList,
  inviteOperatorUser,
  deleteOperatorUser,
  deleteInviteOperatorUser,
  sendOperatorUserEmail,
  fetchInviteOperatorUser,
  createOperatorUser,
  fetchStationCities,
  addStationCity,
  fetchTariffsList,
  fetchPrivacySchedule,
  fetchAccessGroupsList,
  fetchOperatorUsersInvitationsCount,
  fetchOperatorUsersCount,
  changePasswordOrName,
} from './OperatorUserSaga'

import {
  fetchCardList,
  deleteCard,
  updateCard,
  addCard,
  addCardBulk,
  addCardAccessGroups,
  deleteCardAccessGroups,
  fetchCardTransactions,
  fetchCard,
  fetchLocalListFilteredCards,
  fetchCardSessionList,
  fetchCardTransactionStats,
} from './CardSaga'

import {
  fetchOperatorUserActionsChargePoint,
  fetchOperatorUserActions,
  fetchOperatorUserActionsUser,
  fetchOperatorUserActionsChargingToken,
} from './OperatorUserActionsSaga'

import {
  fetchOverview,
  fetchAverageDuration,
  fetchTransactionsStatistics,
  fetchConnectorsStatus,
  fetchPeakHour,
  fetchTopSites,
  fetchTokensStatistics,
  fetchRevenueTrend,
  fetchTokensActivity,
  fetchTopCities,
} from './AnalyticsSaga'

import {
  fetchOperatorsAlerts,
  fetchAlertChargePoints,
  fetchAlertCount,
  editAlert,
  deleteAlert,
  createAlert,
} from './AlertSaga'

import {
  fetchTariffList,
  createTariff,
  updateTariff,
  deleteTariff,
  fetchTariffsCount,
} from './TariffSaga'

export default function* root() {
  yield all([takeLatest(AuthTypes.OPERATOR_USER_LOGIN, operatorUserLogin)])
  yield all([takeLatest(AuthTypes.FETCH_OPERATOR_USER, fetchOperatorUser)])
  yield all([takeLatest(AuthTypes.OPERATOR_USER_LOGOUT, operatorUserLogout)])
  yield all([
    takeLatest(AuthTypes.RESET_PASS_VERIFICATION, resetPassVerification),
  ])
  yield all([takeLatest(AuthTypes.RESET_PASS, resetPass)])
  yield all([takeLatest(AuthTypes.ON_TWO_FACTOR_VERIFY, onTwoFactorVerify)])
  yield all([
    takeLatest(AuthTypes.ON_TWO_FACTOR_SETUP_VERIFY, onTwoFactorSetupVerify),
  ])

  yield all([takeLatest(StationTypes.FETCH_STATION_LIST, fetchStationList)])
  yield all([
    takeLatest(StationTypes.FETCH_STATION_LIST_COUNT, fetchStationListCount),
  ])

  yield all([
    takeLatest(StationTypes.FETCH_STATION_MOVE_LIST, fetchStationMoveList),
  ])
  yield all([takeLatest(StationTypes.UPDATE_STATION, updateStation)])
  yield all([takeLatest(StationTypes.ADD_STATION, addStation)])
  yield all([takeLatest(StationTypes.DELETE_STATION, deleteStation)])
  yield all([
    takeLatest(StationTypes.FETCH_STATION_DETAILS, fetchStationDetails),
  ])

  yield all([
    takeLatest(ChargePointTypes.FETCH_CHARGE_POINT_LIST, fetchChargePointList),
  ])
  yield all([takeLatest(ChargePointTypes.FETCH_CHARGE_POINT, fetchChargePoint)])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_LOG_LIST,
      fetchChargePointLogList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_TRANSACTION_LIST,
      fetchChargePointTransactionList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_CONFIG_LIST,
      fetchChargePointConfigList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_TARIFFS_LIST,
      fetchChargePointTariffsList,
    ),
  ])
  yield all([
    takeLatest(ChargePointTypes.UPDATE_CHARGE_POINT, updateChargePoint),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.UPDATE_CHARGE_POINT_CONFIG,
      updateChargePointConfig,
    ),
  ])
  yield all([
    takeLatest(ChargePointTypes.DELETE_CHARGE_POINT, deleteChargePoint),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.DELETE_CHARGE_POINT_TARIFFS,
      deleteChargePointTariffs,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.ADD_CHARGE_POINT_TARIFFS,
      addChargePointTariffs,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_PRIVACY_SCHEDULE_LIST,
      fetchChargePointPrivacyScheduleList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.DELETE_CHARGE_POINT_PRIVACY_RULES,
      deleteChargePointPrivacyRules,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.ADD_CHARGE_POINT_PRIVACY_RULES,
      addChargePointPrivacyRules,
    ),
  ])
  yield all([takeLatest(ChargePointTypes.ADD_CHARGE_POINT, addChargePoint)])
  yield all([takeLatest(ChargePointTypes.MOVE_CHARGE_POINT, moveChargePoint)])
  yield all([
    takeLatest(
      ChargePointTypes.UPDATE_CHARGE_POINT_FIRMWARE,
      updateChargePointFirmware,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_UPLOAD_DIAGNOSTICS,
      fetchChargePointUploadDiagnostics,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.REQUEST_CHARGE_POINT_UPLOAD_DIAGNOSTICS,
      requestChargePointUploadDiagnostics,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_ACCESS_GROUPS,
      fetchChargePointAccessGroups,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.DELETE_CHARGE_POINT_ACCESS_GROUPS_BULK,
      deleteChargePointAccessGroupsBulk,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.ADD_CHARGE_POINT_ACCESS_GROUPS_BULK,
      addChargePointAccessGroupsBulk,
    ),
  ])
  yield all([
    takeLatest(ChargePointTypes.REVERSE_TRANSACTION, reverseTransaction),
  ])
  yield all([takeLatest(ChargePointTypes.BLOCK_CHARGE_POINT, blockChargePoint)])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_OPERATOR_USER_LIST,
      fetchOperatorUserList,
    ),
  ])
  yield all([
    takeLatest(OperatorUserTypes.FETCH_TARIFFS_LIST, fetchTariffsList),
  ])
  yield all([
    takeLatest(OperatorUserTypes.FETCH_PRIVACY_SCHEDULE, fetchPrivacySchedule),
  ])
  yield all([
    takeLatest(OperatorUserTypes.UPDATE_OPERATOR_USER, updateOperatorUser),
  ])
  yield all([
    takeLatest(OperatorUserTypes.INVITE_OPERATOR_USER, inviteOperatorUser),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LIST,
      fetchInviteOperatorUserList,
    ),
  ])
  yield all([
    takeLatest(OperatorUserTypes.DELETE_OPERATOR_USER, deleteOperatorUser),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.DELETE_INVITE_OPERATOR_USER,
      deleteInviteOperatorUser,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.SEND_OPERATOR_USER_EMAIL,
      sendOperatorUserEmail,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_INVITE_OPERATOR_USER,
      fetchInviteOperatorUser,
    ),
  ])
  yield all([
    takeLatest(OperatorUserTypes.CREATE_OPERATOR_USER, createOperatorUser),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_ACCESS_GROUPS_LIST,
      fetchAccessGroupsList,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_OPERATOR_USERS_INVITATIONS_COUNT,
      fetchOperatorUsersInvitationsCount,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserTypes.FETCH_OPERATOR_USERS_COUNT,
      fetchOperatorUsersCount,
    ),
  ])
  yield all([
    takeLatest(OperatorUserTypes.CHANGE_PASSWORD_OR_NAME, changePasswordOrName),
  ])

  yield all([takeLatest(CardTypes.FETCH_CARD_LIST, fetchCardList)])
  yield all([takeLatest(CardTypes.DELETE_CARD, deleteCard)])
  yield all([takeLatest(CardTypes.UPDATE_CARD, updateCard)])
  yield all([takeLatest(CardTypes.ADD_CARD, addCard)])
  yield all([takeLatest(CardTypes.ADD_CARD_BULK, addCardBulk)])
  yield all([takeLatest(CardTypes.FETCH_CARD, fetchCard)])
  yield all([takeLatest(CardTypes.ADD_CARD_ACCESS_GROUPS, addCardAccessGroups)])
  yield all([
    takeLatest(CardTypes.DELETE_CARD_ACCESS_GROUPS, deleteCardAccessGroups),
  ])
  yield all([
    takeLatest(CardTypes.FETCH_CARD_TRANSACTIONS, fetchCardTransactions),
  ])
  yield all([
    takeLatest(
      CardTypes.FETCH_LOCAL_LIST_FILTERED_CARDS,
      fetchLocalListFilteredCards,
    ),
  ])
  yield all([
    takeLatest(CardTypes.FETCH_CARD_SESSION_LIST, fetchCardSessionList),
  ])
  yield all([
    takeLatest(
      CardTypes.FETCH_CARD_TRANSACTION_STATS,
      fetchCardTransactionStats,
    ),
  ])

  yield all([takeLatest(StationTypes.FETCH_STATION_CITIES, fetchStationCities)])
  yield all([takeLatest(StationTypes.ADD_STATION_CITY, addStationCity)])
  yield all([
    takeLatest(
      StationTypes.FETCH_STATION_MAP_CLUSTERS,
      fetchStationMapClusters,
    ),
  ])
  yield all([
    takeLatest(StationTypes.FETCH_STATION_HEAT_MAP, fetchStationHeatMap),
  ])
  yield all([
    takeLatest(
      StationTypes.FETCH_STATION_MAP_CLUSTERS_SEARCH,
      fetchStationMapClustersSearch,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_UPTIME_STATISTICS,
      fetchChargePointUptimeStatistics,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CONNECTORS_UTILIZATION,
      fetchConnectorsUtilization,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_SUBSCRIBED_ALERTS,
      fetchChargePointSubscribedAlerts,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_ALERTS,
      fetchChargePointAlerts,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.UPDATE_CHARGE_POINT_ALERTS,
      updateChargePointAlerts,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_LOCAL_LIST,
      fetchChargePointLocalList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_CHARGING_PROFILES,
      fetchChargePointChargingProfiles,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.UPDATE_CHARGE_POINT_LOCAL_LIST,
      updateChargePointLocalList,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGE_POINT_COMPOSITE_SCHEDULE,
      fetchChargePointCompositeSchedule,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.CLEAR_CHARGE_POINT_CHARGING_PROFILE,
      clearChargePointChargingProfile,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.CREATE_CHARGE_POINT_CHARGING_PROFILE,
      createChargePointChargingProfile,
    ),
  ])
  yield all([
    takeLatest(ChargePointTypes.FETCH_CONNECTOR_TYPES, fetchConnectorTypes),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.UPLOAD_CHARGE_POINT_FIRMWARE,
      uploadChargePointFirmware,
    ),
  ])

  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGING_SESSION_LOGS,
      fetchChargingSessionLogs,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGING_SESSION_DETAILS,
      fetchChargingSessionDetails,
    ),
  ])
  yield all([
    takeLatest(
      ChargePointTypes.FETCH_CHARGING_SESSION_EVENTS,
      fetchChargingSessionEvents,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGE_POINT,
      fetchOperatorUserActionsChargePoint,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS,
      fetchOperatorUserActions,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_USER,
      fetchOperatorUserActionsUser,
    ),
  ])
  yield all([
    takeLatest(
      OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGING_TOKEN,
      fetchOperatorUserActionsChargingToken,
    ),
  ])
  yield all([
    takeLatest(
      OperatorsAlertTypes.FETCH_OPERATORS_ALERTS,
      fetchOperatorsAlerts,
    ),
  ])
  yield all([
    takeLatest(
      OperatorsAlertTypes.FETCH_ALERT_CHARGE_POINTS,
      fetchAlertChargePoints,
    ),
  ])

  yield all([takeLatest(AnalyticsTypes.FETCH_OVERVIEW, fetchOverview)])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_AVERAGE_DURATION, fetchAverageDuration),
  ])

  yield all([
    takeLatest(
      AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS,
      fetchTransactionsStatistics,
    ),
  ])

  yield all([
    takeLatest(AnalyticsTypes.FETCH_CONNECTORS_STATUS, fetchConnectorsStatus),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_PEAK_HOUR, fetchPeakHour)])
  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_SITES, fetchTopSites)])

  yield all([takeLatest(OperatorsAlertTypes.EDIT_ALERT, editAlert)])
  yield all([takeLatest(OperatorsAlertTypes.DELETE_ALERT, deleteAlert)])
  yield all([takeLatest(OperatorsAlertTypes.CREATE_ALERT, createAlert)])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_TOKENS_STATISTICS, fetchTokensStatistics),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_REVENUE_TREND, fetchRevenueTrend)])
  yield all([
    takeLatest(AnalyticsTypes.FETCH_TOKENS_ACTIVITY, fetchTokensActivity),
  ])
  yield all([
    takeLatest(OperatorsAlertTypes.FETCH_ALERT_COUNT, fetchAlertCount),
  ])
  yield all([takeLatest(AnalyticsTypes.FETCH_TOP_CITIES, fetchTopCities)])

  yield all([takeLatest(TariffTypes.FETCH_TARIFF_LIST, fetchTariffList)])
  yield all([takeLatest(TariffTypes.CREATE_TARIFF, createTariff)])
  yield all([takeLatest(TariffTypes.UPDATE_TARIFF, updateTariff)])
  yield all([takeLatest(TariffTypes.DELETE_TARIFF, deleteTariff)])
  yield all([takeLatest(TariffTypes.FETCH_TARIFFS_COUNT, fetchTariffsCount)])
}
